import axios from 'axios';

export default axios.create({
    // baseURL: "http://127.0.0.1:8080/api",
    baseURL: "https://tstbackend.rullingstock.com/api",
    headers:{
        "content-type":"application/json",
        "Accept":"application/json"
    }
})